<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="materialName" label="材料名称">
               <el-input clearable v-model="formData.materialName" placeholder="请输入材料名称" />
<!--              <el-input clearable v-model="specName" @click.native="dialogVisible = true" placeholder="品种规格" />-->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="entryDate" label="进厂日期">
              <el-date-picker v-model="formData.entryDate" placeholder="请选择进厂日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              <el-date-picker v-model="formData.productionDate" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                type="daterange" clearable format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号">
              <el-input clearable v-model="formData.plateNumber" placeholder="请输入车牌号" />

            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="supplierInfo" label="供应商信息">
              <el-select v-model="formData.supplierInfo" clearable filterable placeholder="请选择供应商">
                <el-option v-for="(item, index) of supplierArr" :value="item.materialsId" :label="item.materialsName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="sampleDate" label="取样日期">
              <el-date-picker v-model="formData.sampleDate" placeholder="请选择取样日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="testDate" label="检测日期">
              <el-date-picker v-model="formData.testDate" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                type="daterange" clearable format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="tankNumber" label="罐号">
              <el-input clearable v-model="formData.tankNumber" placeholder="请输入罐号" />
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="quantity" label="数量">
              <el-input clearable v-model="formData.quantity" placeholder="请输入数量" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="qualityGuaranteePeriod" label="保质期(月)">
              <el-input-number v-model="formData.qualityGuaranteePeriod" :min="1" :step="1" placeholder="请输入保质期（月）" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item prop="supplierReportList" label="供应商检测报告">
              <file-upload v-model="formData.supplierReportList"></file-upload>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="factoryReportList" label="入厂检测报告">
              <file-upload v-model="formData.factoryReportList"></file-upload>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="leadSealAttachList" label="品控验收照片">
              <file-upload v-model="formData.leadSealAttachList"></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="storageTransportAttachList" label="储运验收照片">
              <file-upload v-model="formData.storageTransportAttachList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>
    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>

  </div>
</template>

<script>
import { validInteger } from '@/utils/validator'
import SpecChoose from '@/components/SpecChoose.vue'

export default {
  name: 'ingredientsAdd',
  components: {
    SpecChoose
  },
  data() {
    return {
      specName: '',
      dialogVisible: false,
      supplierArr: [],
      formData: {

        entryDate: '',
        plateNumber: '',
        supplierInfo: '',
        productionDate: '',
        sampleDate: '',
        testDate: '',
        tankNumber: '',
        quantity: '',
        qualityGuaranteePeriod: undefined,
        supplierReportList: [],
        factoryReportList: [],
        leadSealAttachList: [],
        // 储运照片独立提交，原现场照片继续作为品控验收照片。
        storageTransportAttachList: [],
        materialName: ''
      },

      rules: {
        materialName: [
          {
            required: true,
            message: '请输入材料名称',
            trigger: ['blur', 'change']
          }
        ],
        entryDate: [
          {
            required: true,
            message: '请选择进场日期',
            trigger: ['blur', 'change']
          }
        ],
        productionDate: [
          {
            required: true,
            message: '请选择生产日期',
            trigger: ['blur', 'change']
          }
        ],
        plateNumber: [
          {
            required: true,
            message: '请输入车牌号',
            trigger: ['blur', 'change']
          }
          // {
          //   validator: (rule, value, callback) => validateLicensePlate(rule, value, callback)
          // }
        ],
        supplierInfo: [
          {
            required: true,
            message: '请输入供应商信息',
            trigger: ['blur', 'change']
          }
        ],
        sampleDate: [
          {
            required: true,
            message: '请选择取样日期',
            trigger: ['blur', 'change']
          }
        ],
        testDate: [
          {
            required: true,
            message: '请选择检测日期',
            trigger: ['blur', 'change']
          }
        ],
        quantity: [
          {
            required: true,
            message: '请输入数量',
            trigger: ['blur', 'change']
          }
        ],
        qualityGuaranteePeriod: [
          {
            required: true,
            message: '请输入保质期',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (!validInteger.test(String(value))) {
                callback(new Error('保质期必须为正整数'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
        // supplierReport: [
        //   {
        //     required: true,
        //     message: '请上传供应商检测报告',
        //     trigger: ['blur', 'change']
        //   }
        // ],
        // factoryReport: [
        //   {
        //     required: true,
        //     message: '请上传入厂检测报告',
        //     trigger: ['blur', 'change']
        //   }
        // ]

      },
      loading: false

    }
  },
  created() {
    if (this.inspectId) {
      this.loadData()
    }
    this.loadSupplier()
  },
  computed: {
    inspectId() {
      return this.$route.query.inspectId
    },
    imageList1() {
      return this.formData.supplierReportList.map(item => {
        return item.filePrefix + item.fileUrl
      })
    },

    imageList2() {
      return this.formData.factoryReportList.map(item => {
        return item.filePrefix + item.fileUrl
      })
    },
    imageList3() {
      return this.formData.leadSealAttachList.map(item => {
        return item.filePrefix + item.fileUrl
      })
    }

  },
  methods: {
    onSpecSelect(data) {
      console.log('data', data)
      this.formData.materialName = data.specName
      this.specName = data.specName
      this.dialogVisible = false
    },
    loadSupplier() {
      this.$axios.get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByList).then(res => {
        this.supplierArr = res.list || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.ingredients.selectPaMaterialInspectionByInspectId, {
          params: { inspectId: this.inspectId }
        })
        .then(res => {
          this.specName = res.materialName
          res.supplierReportList = res.supplierReportList ? res.supplierReportList : []
          res.factoryReportList = res.factoryReportList ? res.factoryReportList : []
          res.leadSealAttachList = res.leadSealAttachList ? res.leadSealAttachList : []
          res.storageTransportAttachList = res.storageTransportAttachList || []
          res.productionDate = res.productionDate ? res.productionDate.split(',') : []
          res.testDate = res.testDate ? res.testDate.split(',') : []

          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSuccess(res, filed) {
      this.formData[filed].push(res.data)
    },

    delImage(filed, index) {
      this.formData[filed].splice(index, 1)
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.ingredients.insertPaMaterialInspection
          if (this.inspectId) {
            url = this.$apis.ingredients.updatePaMaterialInspection
          }
          const productionDate = this.formData.productionDate.length > 0 ? this.formData.productionDate.join(',') : ''
          const testDate = this.formData.testDate.length > 0 ? this.formData.testDate.join(',') : ''

          this.$axios.post(url, { ...this.formData, productionDate, testDate }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;
  margin-bottom: 10px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
